import { connect } from 'react-redux'
import CaHeader from 'pages/currentawareness/CaHeader'

const mapStateToProps = (state, ownProps) => ({
  flavour: state.layout.flavour,
  aol: ownProps.aol
})

export default connect(mapStateToProps, null)(CaHeader)
